import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import OverrideTable from 'components/core/fields/transformation_parameters/OverrideTable';
import TransformationParameter from 'components/core/fields/transformation_parameters/TransformationParameter';
import MessageBox from 'components/core/MessageBox';
import RIENumber from 'components/core/editable/RIENumber';
import DatastreamDefaultsTable from 'components/core/fields/transformation_parameters/DatastreamDefaultsTable.js';


export default class MissingValueParameter extends TransformationParameter {
    static defaultProps = {
        parameterNames: ['missing_value'],
        isOverridable: true,
        isDatastreamDefaultVisibileInitially: true,
        isOverrideVisibleInitially: true,
        infoBoxText: '',
    };

    renderMessageBox = () => {
        const preListText = 'We could not find a missing_value attribute for the following variables:';
        return (
            <MessageBox includeIcon>
                <Flexbox flexDirection={'column'}>
                    {this.getMessageBoxVariableList(preListText)}
                    <p>A default missing_value of -9999 will be used.</p>
                </Flexbox>
            </MessageBox>
        );
    };

    renderDatastreamDefaultQuestionText = () => {
        return 'Do you want to set missing value by input datastream?';
    };

    renderOverrideQuestionText = () => {
        return 'Do you want to set missing value by variable?';
    };

    renderDatastreamDefaultTable = () => {
        return (
            <MissingValueDatastreamDefaultsTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                displayInputDatastream={this.props.displayInputDatastream}
                hasWritePermissions={this.props.hasWritePermissions}
                className={css`width:100%;`}
            />
        );
    };

    renderOverrideTable = () => {
        return (
            <MissingValueOverrideTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                hasWritePermissions={this.props.hasWritePermissions}
                displayInputDatastream
            />
        );
    }
}

class MissingValueOverrideTable extends OverrideTable {

    renderMissingValue = (data) => {
        const value = this.getValue(data);

        return (
            <RIENumber
                value={value}
                change={this.onValueChange}
                fieldPath={this.getFieldPath(this.props.parameterNames[0], data)}
                onChangeData={data}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                formDisplay
                isDisabled={!this.props.hasWritePermissions}
            />
        );
    };

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'missing_value',
                    props: {
                        style: {
                            whiteSpace: 'nowrap',
                        }
                    }
                },
                cell: {
                    formatters: [
                        data => { return this.renderMissingValue(data); }
                    ]
                }
            }
        ]);
    }
}

class MissingValueDatastreamDefaultsTable extends DatastreamDefaultsTable {

    renderMissingValue = (data) => {
        const value = this.getValue(data);

        return (
            <RIENumber
                value={value}
                change={this.onValueChange}
                fieldPath={[]}
                onChangeData={{ name: data.name }}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                formDisplay
                isDisabled={!this.props.hasWritePermissions}
            />
        );
    };

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'missing_value',
                    props: {
                        style: {
                            whiteSpace: 'nowrap',
                        }
                    }
                },
                cell: {
                    formatters: [
                        data => { return this.renderMissingValue(data); }
                    ]
                }
            }
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/transformation_parameters/MissingValueParameter.js